import { Injectable } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { TimeTrackingDetail } from 'src/app/model/cpl-time-tracking.model';
import { TimeTrackingHelperService } from '../time-tracking-helper/time-tracking-helper.service';
import { UserTimeTrackingForm } from '../../model/user-time-tracking-form/user-time-tracking-form.model';
import { CommonValidators, DateHelpers } from '@edl-development/edl-common';
import { UserTimeTrackingSubmission } from '../../model/user-time-tracking-form/user-time-tracking-submission.model';
import { HOURS_MAX_DIGITS, HOURS_MAX_DIGITS_AFTER_DECIMAL } from 'src/app/constants/a48.constants';

@Injectable()
export class UserTimeTrackingFormService {
    constructor(
        private formBuilder: FormBuilder,
        private timeTrackingHelperService: TimeTrackingHelperService
    ) {}

    public buildForm(
    {
        userFlexDetails,
        itemFlexDetails,
        isCompleted,
        disabled = false
    }:{
        userFlexDetails: TimeTrackingDetail | undefined | null, 
        itemFlexDetails: TimeTrackingDetail | undefined | null, 
        isCompleted: boolean,
        disabled: boolean
    }): UserTimeTrackingForm {
        const detailsOrDefault = this.timeTrackingHelperService.getTimeTrackingDetailOrDefault(isCompleted, userFlexDetails, itemFlexDetails);

        return this.formBuilder.group({
            Hours: [{ value: detailsOrDefault.Hours, disabled }, [Validators.required, CommonValidators.isGreaterThanZero(), CommonValidators.isValidDecimal(HOURS_MAX_DIGITS, HOURS_MAX_DIGITS_AFTER_DECIMAL)]],
            Confirmed: [{ value: detailsOrDefault.Confirmed, disabled }, [Validators.required]],
            EventName: [{ value: detailsOrDefault.EventName, disabled }, [Validators.required]],
            EventStartDate: [{ value: detailsOrDefault?.EventStartDate, disabled }, [Validators.required]],
            EventEndDate: [{ value: detailsOrDefault?.EventEndDate, disabled }, [Validators.required]]
        });
    }


    public packageForm(form: UserTimeTrackingForm): UserTimeTrackingSubmission {
        return form.value as UserTimeTrackingSubmission;
    }
}
